'use strict'

/**
 * @foundation - Class Event Base
 * ===========================================
 */

export default class ClassEvent {
  constructor() {
    this.eventsListeners = []
  }

  on(events, handler, priority) {
    if (typeof handler !== 'function') return this
    const method = priority ? 'unshift' : 'push'
    events.split(' ').forEach((event) => {
      if (!this.eventsListeners[event]) {
        this.eventsListeners[event] = []
      }
      this.eventsListeners[event][method](handler)
    })
    return this
  }

  once(events, handler, priority) {
    const self = this
    if (typeof handler !== 'function') return self
    function onceHandler(...args) {
      handler.apply(self, args)
      self.off(events, onceHandler)
      if (onceHandler.f7proxy) {
        delete onceHandler.f7proxy
      }
    }
    onceHandler.f7proxy = handler
    return self.on(events, onceHandler, priority)
  }

  off(events, handler) {
    const self = this
    if (!self.eventsListeners) return self
    events.split(' ').forEach((event) => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = []
      } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || (eventHandler.f7proxy && eventHandler.f7proxy === handler)) {
            self.eventsListeners[event].splice(index, 1)
          }
        })
      }
    })
    return self
  }

  emit(...args) {
    if (!this.eventsListeners) return this
    let events
    let data
    let context
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0]
      data = args.slice(1, args.length)
      context = this
    } else {
      events = args[0].events
      data = args[0].data
      context = args[0].context || this
    }
    const eventsArray = Array.isArray(events) ? events : events.split(' ')
    eventsArray.forEach((event) => {
      if (this.eventsListeners && this.eventsListeners[event]) {
        const handlers = []
        this.eventsListeners[event].forEach((eventHandler) => {
          handlers.push(eventHandler)
        })
        handlers.forEach((eventHandler) => {
          eventHandler.apply(context, data)
        })
      }
    })
    return this
  }
}
